// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--Woze7","icon":"a10a3f92e9--icon--IKO1G","icon--inner":"a10a3f92e9--icon--inner--sAM5W","tooltip":"a10a3f92e9--tooltip--pHDMN"};